import { render, staticRenderFns } from "./inicial.vue?vue&type=template&id=6025a382&scoped=true"
import script from "./inicial.vue?vue&type=script&lang=js"
export * from "./inicial.vue?vue&type=script&lang=js"
import style0 from "./inicial.vue?vue&type=style&index=0&id=6025a382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6025a382",
  null
  
)

export default component.exports